import React, { Component } from 'react';

import { Tree } from 'antd';

import layouts from '../../layouts';

const TreeNode = Tree.TreeNode;

export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            treeUpdateTime: Date.now()
        }
    }

    componentDidMount() {
        this.querySearch();

        if(typeof this.props.api === 'function') {
            this.props.api(this);
        }
    }

    querySearch() {
        if(this.props.querySearchById){
            return this.props.service.querySearchImportFolderById(
                this.props.querySearchById
            ).then(response => {
                this.setState({
                    treeUpdateTime: Date.now(),
                    data: response.data
                });
            });
        }
        return this.props.service.querySearchImportFolder({
            authType: this.props.showByAuth
        }).then(response => {
            this.setState({
                treeUpdateTime: Date.now(),
                data: response.data
            });
        });
    }

    nodes(data) {
        return data.map((d) => {
            return (
                <TreeNode title={d.label} key={d.key}>
                    {this.nodes(d.children || [])}
                </TreeNode>
            );
        });
    }
    
    onSelect(selectedKeys, label, disabled, event) {
        //this.props.handleChange(selectedKeys[0]);
        if(typeof this.props.onSelect === 'function') {
            this.props.onSelect(selectedKeys[0],disabled);
        }
    }

    render() {
        const { data } = this.state;
        const { expands} = this.props;
        return (
            <div className="app-ztree">
                <div className="apps-tree">
                    <div className="apps-tree-container">
                        {/* <Tree
                            showLine
                            defaultExpandedKeys={expands}
                            onSelect={this.onSelect.bind(this)}
                        >
                        {this.nodes(data)}
                        
                        </Tree> */}
                        <layouts.Tree treeUpdateTime={this.state.treeUpdateTime} onSelect={this.onSelect.bind(this)} data={data} {...this.props} />
                        
                    </div>
                </div>
                
            </div>
        );
    }
}
